import axios from 'axios'

const toFormData = (data = {}) => {
  const formData = new FormData()

  Object.keys(data).forEach(key => {
    const value = data[key]

    if (value === undefined || value === null || value === '') {
      return
    }

    formData.append(key, value)
  })

  return formData
}

const AnnouncementService = {
  async getList (params = {}) {
    return axios.get('admin/announcements', { params })
  },

  async show (id) {
    return axios.get(`admin/announcements/${id}`)
  },

  async store (data) {
    return axios.post('admin/announcements', toFormData(data), {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async update (id, data) {
    const formData = toFormData(data)
    formData.append('_method', 'PUT')

    return axios.post(`admin/announcements/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async destroy (id) {
    return axios.delete(`admin/announcements/${id}`)
  }
}

export default AnnouncementService
